import { FinderTheme } from '../models/finder/finder.model';

/** Default VR Bank theme when no organization theme is configured. */
export const VR_THEME: FinderTheme = {
  primaryColor: '#0066B3',
  accentColor: '#FF6600',
  backgroundColor: '#FFFFFF',
  textColor: '#002D67',
  borderRadius: 8,
  fontFamily: "'Genos GFG', sans-serif",
  buttonStyle: 'filled',
};
